import { Component, Input } from '@angular/core';
import { Price } from 'src/app/core/models/cancellation.model';
import { ExchangeFare } from 'src/app/core/models/voluntary-change.model';

@Component({
  selector: 'app-box-fare',
  templateUrl: './box-fare.component.html',
  styleUrls: ['./box-fare.component.scss']
})
export class BoxFareComponent {
  @Input() title: string;
  @Input() totalTitle: string;
  @Input() totalValue: Price;
  @Input() totalColorRed = false;
  @Input() totalColorGreen = false;
  @Input() paddingless = false;
  @Input() divider = true;
  @Input() exchangeFare: ExchangeFare;
  @Input() fbCodes: string[];
  @Input() showFBCodes: boolean = false;

  constructor() {}
}
